<template>
  <section
    v-if="show"
    :class="[
      'FeatureMask feature-mask-container',
      showUpgradeOn === 'hover' && 'show-upgrade-on-hover',
      showUpgradeOn === 'always' && 'show-upgrade-on-always',
      show === true && 'show',
    ]"
    :style="wrapperStyle"
    @click.stop="handleSectionClick"
  >
    <div
      v-if="mode !== 'transparent'"
      class="lock-icon-wrapper"
    >
      <AM3Icon
        width="28px"
        name="lock"
        color="white"
      />
    </div>
    <CardContainer
      v-if="mode !== 'transparent'"
      class="modal-wrapper"
    >
      <AM3Icon
        v-if="iconName"
        :name="iconName"
        color="#7344c0"
        :wrapper-style="{
          display: 'inline-flex',
          alignItem: 'center',
          justifyContent: 'center',
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          background: '#f6f9fc',
        }"
        class="mb-5"
      />
      <div
        v-if="showPremiumTag"
        class="tag-container"
        :style="{
          backgroundColor: '#E39425',
        }"
      >
        <span
          class="text-[10px] font-bold text-white"
        >
          PREMIUM
        </span>
      </div>
      <span
        class="text-sm font-bold"
      >
        {{ title }}
      </span>
      <span
        class="message text-xs leading-[25px] text-center mt-2.5"
        v-html="message"
      />
      <AM3Button
        v-if="showUpgradeNowButton"
        label="Upgrade now"
        icon="lock"
        :icon-props="{
          size: 'sm',
        }"
        :style="{
          marginTop: '26px',
        }"
        variant="success"
        @click="handleUpgradeClick"
      />
    </CardContainer>
  </section>

<!--  <slot /> -->
</template>

<script>
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'
import AM3Button from '@/components/am3-generic/base/AM3Button.vue'
import CardContainer from '@/components/am3/containers/CardContainer.vue'

export default {
  name: 'FeatureLockerSection',
  components: {
    AM3Icon,
    AM3Button,
    CardContainer,
  },
  emits: ['update:show'],
  props: {
    mode: {
      type: String,
      default: 'default',
      validator: val => ['default', 'transparent'].indexOf(val) > -1,
    },
    show: {
      type: Boolean,
      default: false,
    },
    showUpgradeOn: {
      type: String,
      default: 'hover',
      validator: val => ['hover', 'always'].indexOf(val) > -1,
    },
    showUpgradeNowButton: {
      type: Boolean,
      default: true,
    },
    showPremiumTag: {
      type: Boolean,
      default: null,
    },
    iconName: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    margin: {
      type: Object,
      default: () => ({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }),
      validator: (val) => { // Make sure
        return val
          && typeof val.top === 'number'
          && typeof val.right === 'number'
          && typeof val.bottom === 'number'
          && typeof val.left === 'number'
      },
      errorMessage: 'Either provide null or complete margin object with "top", "right", "bottom", "left" in form of Number',
    },
  },

  data() {
    return {
      store: null, // We inject our vuex $store here, since this component won't be bound with Vuex by default
      showFeatureMask: {
        get() {
          return this.show
        },
        set(val) {
          this.$emit('update:show', val)
        },
      },
    }
  },
  computed: {
    wrapperStyle() {
      return {
        top: this.margin.top,
        left: this.margin.left,
        width: `calc(100% - ${this.margin.left} - ${this.margin.right})`,
        height: `calc(100% - ${this.margin.top} - ${this.margin.bottom})`,
        opacity: this.mode === 'transparent' ? 0 : 1,
      }
    },
  },
  watch: {
    show(val) {
      this.showFeatureMask = val
    },
  },
  created() {
  },
  methods: {
    async showUpgradeConfirmModal() {
      const ans = await this.store.dispatch('SHOW_CONFIRM', {
        title: this.title,
        messageHtml: this.message,
        hideCancelButton: true,
        confirmButtonText: 'Done',
      })
      if (!ans) {
        return
      }
      // After we have payment page
      // this.$router.push('/payment');
    },
    handleUpgradeClick() {
      if (this.mode !== 'default') return
      window.open('https://www.audiencerepublic.com/book-a-demo', '_blank')
    },

    async handleSectionClick(event) {
      // event.stopPropagation();
      if (this.mode !== 'transparent') {
        return
      }
      this.showUpgradeConfirmModal()
    },
  },
}
</script>

<style scoped>
.FeatureMask::before {
  content: '';
  inset: 0;
  position: absolute;
  z-index: 0;
}
.FeatureMask {
  position: absolute;
  display: flex;
  overflow: hidden;
  background: rgba(67, 81, 107, 0.6);
  z-index: 3;
  cursor: pointer;
  inset: 0;
}
.FeatureMask .lock-icon-wrapper {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  transform: translateX(-50%) translateY(-50%);
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 1;
}
.FeatureMask .modal-wrapper {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: calc(100% - 40px);
  margin: 0 auto;
  max-width: 740px;
  padding: 40px 30px;
  z-index: 2;
  opacity: 0;
  transition: all 0.3s;
  transition-delay: 0.3s;
}
.FeatureMask .modal-wrapper .message { margin-top: 10px; }
.FeatureMask.show-upgrade-on-hover:hover .modal-wrapper {
  opacity: 1;
  transition-delay: 0.15s;
}
.FeatureMask.show-upgrade-on-always .modal-wrapper { opacity: 1; }
.FeatureMask .tag-container {
  border-radius: 20px;
  margin-left: 10px;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: fit-content;
  padding: 5px 10px;
  margin-bottom: 12px;
}
</style>
